import { parseNum } from './numero.js';
/* distribuicao.ts — reparte o ano pelos doze meses. */
const CHAVES_MES = [
    'm01', 'm02', 'm03', 'm04', 'm05', 'm06',
    'm07', 'm08', 'm09', 'm10', 'm11', 'm12',
];
/**
 * distribuicaoMensal(p, cen): volume e resultado mês a mês, mais o mês em que
 * a margem acumulada cobre as despesas fixas do ano.
 *
 * Separação importante entre VOLUME e FORMA DA CURVA:
 *
 *   - O volume anual (V12) já veio pronto em `montarParametros`, ANUALIZADO
 *     pela cobertura. 10 projetos em 6 meses são 20 no ano, e essa conta não
 *     se repete aqui.
 *
 *   - A FORMA da curva (qual mês é forte, qual é fraco) só é conhecível com um
 *     ano inteiro de histórico. Com 6 meses de dados não dá para saber se o
 *     segundo semestre repete o primeiro — projetar a curva do semestre
 *     medido sobre o ano inteiro inventaria sazonalidade que ninguém mediu.
 *     Nesse caso a distribuição é UNIFORME e o retorno traz `uniforme: true`
 *     para a tela avisar que é estimativa.
 */
export function distribuicaoMensal(p, cen) {
    const anoCompleto = !p.coberturaSaz || p.coberturaSaz >= 12;
    let pesos = [];
    let perfilReal = false;
    if (anoCompleto) {
        const brutos = CHAVES_MES.map((k) => (p.meses ? parseNum(p.meses[k]?.projetos) : 0));
        const soma = brutos.reduce((s, v) => s + v, 0);
        if (soma > 0) {
            pesos = brutos.map((v) => v / soma);
            perfilReal = true;
        }
    }
    // Cai aqui em dois casos: cobertura parcial, ou doze meses cadastrados mas
    // todos com zero projeto (o usuário preencheu só os valores, ou salvou a
    // tela em branco). Nos dois a curva é chute igualitário.
    //
    // DIVERGÊNCIA CONSCIENTE do app-core.js: lá o segundo caso devolvia
    // `uniforme: false`, ou seja, a tela dizia "este é o seu perfil sazonal"
    // exibindo doze barras idênticas que ninguém mediu. A flag existe para
    // sinalizar "isto é estimativa"; devolver false aqui era mentir para a UI.
    // Os NÚMEROS são idênticos aos do original — muda só a honestidade da flag.
    if (!perfilReal)
        pesos = CHAVES_MES.map(() => 1 / 12);
    const fixasAno = p.despFixa * 12;
    let mcAcum = 0;
    let mesEquilibrio = null;
    const linhas = pesos.map((peso, i) => {
        const projetos = p.V12 * peso;
        const mc = cen.mcUnit * projetos;
        mcAcum += mc;
        // `fixasAno > 0` evita declarar "equilíbrio em janeiro" para quem não
        // cadastrou despesa fixa nenhuma — ali não há equilíbrio a atingir, e o
        // dado ausente não deve virar boa notícia.
        if (mesEquilibrio === null && fixasAno > 0 && mcAcum >= fixasAno)
            mesEquilibrio = i;
        return { mes: i, projetos, faturamento: cen.ticket * projetos, mc, mcAcumulada: mcAcum };
    });
    return { linhas, mesEquilibrio, fixasAno, uniforme: !perfilReal };
}
//# sourceMappingURL=distribuicao.js.map